/* eslint-disable react/destructuring-assignment */

import React, { useContext } from 'react';
import { AuthContext } from 'contexts';
import NotificationSettings, {
  NotificationSettingsProps,
} from './NotificationSettings';

const NotificationSettingsWrapper: React.FC<
  NotificationSettingsProps & { isExternal?: boolean }
> = ({ isExternal, ...props }) => {
  const { auth, fetchAuth } = useContext(AuthContext);

  if (isExternal) {
    return <NotificationSettings {...props} />;
  }

  return <NotificationSettings {...props} auth={auth} fetchAuth={fetchAuth} />;
};

export default NotificationSettingsWrapper;
